module.exports = __webpack_public_path__ + "static/media/ciudadania-ETICA.af67f754.svg";